/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_X13_Error_DeniedInputs */

const en_portal_x13_error_denied = /** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sign-in was cancelled. Try again or use the email link.`)
};

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const ar_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const he_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const ur_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const es_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const fr_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const de_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const pt_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const hi_portal_x13_error_denied = en_portal_x13_error_denied;

/** @type {(inputs: Portal_X13_Error_DeniedInputs) => LocalizedString} */
const bn_portal_x13_error_denied = en_portal_x13_error_denied;

/**
* | output |
* | --- |
* | "The sign-in was cancelled. Try again or use the email link." |
*
* @param {Portal_X13_Error_DeniedInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const portal_x13_error_denied = /** @type {((inputs?: Portal_X13_Error_DeniedInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_X13_Error_DeniedInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_portal_x13_error_denied(inputs)
	if (locale === "he") return he_portal_x13_error_denied(inputs)
	if (locale === "ur") return ur_portal_x13_error_denied(inputs)
	if (locale === "es") return es_portal_x13_error_denied(inputs)
	if (locale === "fr") return fr_portal_x13_error_denied(inputs)
	if (locale === "de") return de_portal_x13_error_denied(inputs)
	if (locale === "pt") return pt_portal_x13_error_denied(inputs)
	if (locale === "hi") return hi_portal_x13_error_denied(inputs)
	if (locale === "bn") return bn_portal_x13_error_denied(inputs)
	return /** @type {LocalizedString} */ ("The sign-in was cancelled. Try again or use the email link.")
});